module.exports = __webpack_public_path__ + "img/58800.0c25b451.jpg";